import React from 'react'
import { useContext, useEffect, useState } from 'react'
import { CartContext } from '../contexts/CartContext'
import { Navbar } from '../components/Navbar'
import styled from "styled-components"
import { Link } from "react-router-dom"

const Div = styled.div`
    display:flex;
    flex-direction:column;
    margin:1rem;
    /* border:2px solid red; */
    padding-left:1%;
    
    /* border:1px solid black; */

    div{
        /* border:2px solid black; */
    }
`


const CheckoutItem = styled.div`
margin-top:2rem;
    display:grid;
    grid-template-columns:1fr 3fr 2fr  ;
    grid-gap:1rem;
`

const CheckOutDiv = styled.div`
    display:grid;
    grid-template-columns:2fr 1fr ;
    grid-gap:1rem;
    border-top:1px solid #e4dede;
;
    margin-top:1rem;
`

export const FilledCart = () => {
    const { cart } = useContext(CartContext)
    const [total, setTotal] = useState(0)
  

    useEffect(() => {
        let total = 0

        cart.map(item => {
            total += item.price
        })
        setTotal(total)
    },[cart])

    return (
        <>

            <Navbar />

            <Div>
                <div className="cart-first-div">
                    <button className="shopping-bag-btn">Shopping Bag(0)</button>
                    <button className="save-for-later-btn">Save for Later</button>


                    <div>
                        <p > Shopping Bag</p>
                        <p>

                            <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.11111 10.5239H16.5556V16H2.11111V10.5239ZM1 6.95245H17.6667V10.5239H1V6.95245Z" stroke="black" />
                                <path d="M9.33337 6.72308V15.7706" stroke="black" stroke-width="2" />
                                <path d="M14.7278 1.35491C13.9745 0.579915 12.2367 1.11801 10.8412 2.55966C10.5812 2.83018 10.3446 3.12544 10.1345 3.4418C9.29894 4.66798 9.07005 5.95011 9.6745 6.57391C10.4256 7.35129 12.1678 6.8132 13.5612 5.37273C13.7567 5.17154 13.9301 4.96202 14.0889 4.7525C15.0734 3.45013 15.3745 2.02514 14.7278 1.35491V1.35491ZM3.93894 1.35491C4.69005 0.578725 6.43227 1.11801 7.82672 2.55966C8.10005 2.84299 8.33116 3.14061 8.53561 3.4418C9.36894 4.66798 9.59783 5.95011 8.99227 6.57391C8.24116 7.35129 6.50116 6.8132 5.10338 5.37273C4.91762 5.17693 4.74252 4.96984 4.57894 4.7525C3.59227 3.45013 3.29116 2.02514 3.93894 1.35491Z" stroke="black" />
                            </svg>Choose gift options when you check out.</p>
                        <p>Items in your bag are not on hold.</p>
                    </div>
                </div>



                <div className="cart-second-div">
                    <div className="cart-inner-div-1" >
                        <div>
                            {
                                cart.map((item) => {
                                    return (
                                        <CheckoutItem>

                                            <div>   <img style={{ width: '100%' }} src={item.imageURL} alt="" /></div>

                                            <div>
                                                <div>
                                                    <p style={{ fontsize: "13px", color: "#00823F", fontWeight: "700" }}  >Arrives before Christmas</p>

                                                    <p style={{ fontsize: "13px", fontWeight: "390" }} >{item.brand}</p>

                                                    <p style={{ fontsize: "15px", fontWeight: "390", marginBottom: "0.8rem" }}>{item.productName} </p>

                                                    <p style={{ fontsize: "15px", fontWeight: "390" }}>Size:One Size</p>
                                                    <p style={{ fontsize: "15px", fontWeight: "390" }}>Color:{item.color}</p>
                                                    <p style={{ fontsize: "15px", fontWeight: "390", marginBottom: "0.8rem" }}>Item:{item.id}</p>
                                                </div>

                                                <div  >
                                                    <p>
                                                        <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M20.498 11.372H23.5V7.924L19.6 5.442L18.028 0.697998H0.5V11.372H3.13M6.998 11.372H16.638H6.998Z" stroke="#393939" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M5.06799 13.302C6.13445 13.302 6.99899 12.4375 6.99899 11.371C6.99899 10.3045 6.13445 9.44 5.06799 9.44C4.00153 9.44 3.13699 10.3045 3.13699 11.371C3.13699 12.4375 4.00153 13.302 5.06799 13.302Z" stroke="#393939" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M18.568 13.302C19.6345 13.302 20.499 12.4375 20.499 11.371C20.499 10.3045 19.6345 9.44 18.568 9.44C17.5015 9.44 16.637 10.3045 16.637 11.371C16.637 12.4375 17.5015 13.302 18.568 13.302Z" stroke="#393939" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                                        </svg>

                                                        Delivery</p>
                                                    <p>
                                                        International orders usually arrive within 5–13 business days. We'll give you delivery dates in checkout.
                                                    </p>

                                                    <div className="remove-save-btn">
                                                        <button>Remove</button>
                                                        <button>Save for later</button>
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="price">
                                                <p style={{textAlign:"right"}}>₹{item.price}</p>
                                            </div>



                                        </CheckoutItem>
                                    )
                                })

                            }
                        </div>


                        <CheckOutDiv>

                            <div>
                                <p className="payment-methods">Accepted Payment Methods</p>
                                <p className="Need-help">
                                    Need help? Call 1.888.282.6060 or <span className='blue'>chat with us</span>
                                </p>
                                <p className='blue'> Shipping internationally?</p>
                            </div>

                            <div className="total-checkout-div">

                                <div>
                                    <p >Subtotal </p>
                                    <p>₹ {total}</p>
                                </div>
                                <button>
                                    <Link style={{ color: "white" }} to="/check1">Checkout</Link>
                                </button>
                            </div>

                        </CheckOutDiv>

                    </div>
                    <div style={{borderLeft: "1px solid #e3e3e3",marginTop: "1rem"}}>

                    </div>


                    <div className="cart-inner-div-2"></div>
                </div>


            </Div>
            <div className="horizontal-line">{/* horizontal line */}</div>




        </>
    )

}

